import type { IconName } from "@similarweb/icons";

import type { CrmEnrichmentJobType, CrmProvider } from "app/pages/sales-intelligence/modules/crm-enrichment/types/types";

const JOB_ICON_CONFIG: Record<CrmProvider, IconName> = {
    salesforce: "salesforce-cloud",
    hubspot: "hubspot-cloud",
    dynamics: "dynamics-colored",
};

type JobConfig = {
    type: CrmEnrichmentJobType;
    iconName: (crmProvider: CrmProvider) => IconName;
};

export const JOB_TYPE_CONFIG: ReadonlyArray<JobConfig> = [
    {
        type: "instant",
        iconName: (crmProvider: CrmProvider) => JOB_ICON_CONFIG[crmProvider],
    },
    {
        type: "scheduled",
        iconName: () => "select-how-to-contactUs-calander",
    },
];
